import * as krakenModels from '@/model/config/krakenModels';

export const launchRegister = async () => {
  krakenModels.registerOpen();
};

export const launchDeposit = async () => {
  krakenModels.openDeposit();
};
